import type { CSSProperties } from "react";
import styles from "./Avatar.module.css";

// Цвета фона аватара из палитры Figma; белые инициалы читаются на каждом.
const palette = [
  "var(--color-secondary-medium)",
  "var(--color-primary-medium)",
  "var(--color-secondary-dark)",
  "var(--color-primary-dark)",
];

/** Цвет аватара зависит только от `userId`, поэтому человек выглядит одинаково на всех экранах. */
export function avatarColor(userId: string): string {
  let hash = 0;
  for (const char of userId) hash = (hash * 31 + char.charCodeAt(0)) >>> 0;
  return palette[hash % palette.length]!;
}

function initial(name: string | null | undefined): string {
  const [first] = Array.from(name?.trim() ?? "");
  return first?.toLocaleUpperCase("ru") ?? "?";
}

/** Avatar из Figma: первая буква имени на цветном круге. Декоративный — имя всегда рядом текстом. */
export function Avatar({ userId, name, size = 34 }: { userId: string; name: string | null | undefined; size?: number }) {
  const style = { "--avatar-color": avatarColor(userId), "--avatar-size": `${size}px` } as CSSProperties;
  return (
    <span className={styles.avatar} style={style} aria-hidden="true">
      {initial(name)}
    </span>
  );
}
